import { render, staticRenderFns } from "./SeminarMethodParameters.vue?vue&type=template&id=46542c46"
import script from "./SeminarMethodParameters.vue?vue&type=script&lang=js"
export * from "./SeminarMethodParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports